import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import DeleteGorbeaSeasonDataModal from './DeleteGorbeaSeasonDataModal';
export default class GorbeaTaldezainaPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "savingDeadline", false);
    _defineProperty(this, "savingResults", false);
    _defineProperty(this, "recalculating", false);
    _defineProperty(this, "scrapingClasificacion", false);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "selectedSeasonId", 0);
    _defineProperty(this, "selectedSeason", null);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "players", []);
    // Result State
    _defineProperty(this, "classification", []);
    // Ordered array of rival IDs (strings)
    _defineProperty(this, "maxGoleadorLiga", []);
    _defineProperty(this, "maxGoleadorTotal", []);
    _defineProperty(this, "maxAsistenteLiga", []);
    _defineProperty(this, "maxAsistenteTotal", []);
    _defineProperty(this, "resultadoCopa", '');
    _defineProperty(this, "porteriasCero", 0);
    _defineProperty(this, "goleadasFavor", 0);
    _defineProperty(this, "goleadasContra", 0);
    // Season Deadline State
    _defineProperty(this, "fechaCierreInput", '');
    // Drag and drop state
    _defineProperty(this, "draggedIndex", null);
    _defineProperty(this, "copaOptions", ['Primera ronda', 'Segunda ronda', 'Dieciseisavos de final', 'Octavos de final', 'Cuartos de final', 'Semifinales (ida y vuelta)', 'Final', 'Campeón']);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadInitialData();
  }
  loadInitialData() {
    this.loading = true;
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pPlayers = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players'
    });
    Promise.all([pSeasons, pPlayers]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        seasonsResp = _ref2[0],
        playersResp = _ref2[1];
      this.seasons = (app.store.pushPayload(seasonsResp) || []).filter(s => s.name().replace(/\//g, '-') >= '2025-2026');
      // Sort seasons descending
      this.seasons.sort((a, b) => b.name().localeCompare(a.name()));
      this.players = app.store.pushPayload(playersResp) || [];
      const primaryTeamId = app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
      this.players = this.players.filter(p => p.isActive() && p.attribute('entityType') === 'player' && (p.teams() || []).some(t => String(t.id()) === String(primaryTeamId)));
      this.players.sort((a, b) => a.name().localeCompare(b.name()));
      if (this.seasons.length > 0) {
        this.selectedSeasonId = parseInt(this.seasons[0].id());
        this.selectedSeason = this.seasons[0];
        this.loadSeasonResult();
      } else {
        this.loading = false;
        m.redraw();
      }
    }).catch(err => {
      this.loading = false;
      m.redraw();
    });
  }
  onSeasonChange(seasonId) {
    this.selectedSeasonId = seasonId;
    this.selectedSeason = this.seasons.find(s => parseInt(s.id()) === seasonId);
    this.loadSeasonResult();
  }
  loadSeasonResult() {
    this.loading = true;

    // Initialize/format deadline input
    if (this.selectedSeason) {
      const closingDate = this.selectedSeason.fechaCierreVotacionesPastorGorbea();
      if (closingDate) {
        // Format date for datetime-local input: YYYY-MM-DDTHH:mm
        const d = new Date(closingDate);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        this.fechaCierreInput = "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes);
      } else {
        this.fechaCierreInput = '';
      }
    }
    const seasonParam = this.selectedSeason ? this.selectedSeason.name().replace('/', '-') : '2025-2026';

    // Load rivals for this season and official results in parallel
    const pRivals = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals?season=".concat(seasonParam)
    });
    const pResult = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-result',
      params: {
        season_id: this.selectedSeasonId
      }
    });
    Promise.all([pRivals, pResult]).then(_ref3 => {
      let _ref4 = _slicedToArray(_ref3, 2),
        rivalsResp = _ref4[0],
        resultResp = _ref4[1];
      const allRivals = app.store.pushPayload(rivalsResp) || [];
      this.rivals = allRivals.filter(r => r.attribute('division') === '1ª');
      const parsePlayerIds = val => {
        if (!val) return [];
        if (Array.isArray(val)) return val.map(v => parseInt(v, 10)).filter(n => !isNaN(n) && n > 0);
        if (typeof val === 'number') return val > 0 ? [val] : [];
        if (typeof val === 'string') {
          try {
            const parsed = JSON.parse(val);
            if (Array.isArray(parsed)) return parsed.map(v => parseInt(v, 10)).filter(n => !isNaN(n) && n > 0);
          } catch (e) {}
          const num = parseInt(val, 10);
          return !isNaN(num) && num > 0 ? [num] : [];
        }
        return [];
      };
      if (resultResp && resultResp.data) {
        const result = resultResp.data.attributes;
        this.classification = result.classification || [];
        this.maxGoleadorLiga = parsePlayerIds(result.maxGoleadorLiga);
        this.maxGoleadorTotal = parsePlayerIds(result.maxGoleadorTotal);
        this.maxAsistenteLiga = parsePlayerIds(result.maxAsistenteLiga);
        this.maxAsistenteTotal = parsePlayerIds(result.maxAsistenteTotal);
        this.resultadoCopa = result.resultadoCopa || '';
        this.porteriasCero = result.porteriasCero !== null ? parseInt(result.porteriasCero) : 0;
        this.goleadasFavor = result.goleadasFavor !== null ? parseInt(result.goleadasFavor) : 0;
        this.goleadasContra = result.goleadasContra !== null ? parseInt(result.goleadasContra) : 0;
      } else {
        // Reset state for new season/results
        this.classification = [];
        this.maxGoleadorLiga = [];
        this.maxGoleadorTotal = [];
        this.maxAsistenteLiga = [];
        this.maxAsistenteTotal = [];
        this.resultadoCopa = '';
        this.porteriasCero = 0;
        this.goleadasFavor = 0;
        this.goleadasContra = 0;
      }

      // Sync classification array to contain all current Primera Division rivals
      const currentIds = this.rivals.map(r => String(r.id()));
      if (this.classification.length === 0) {
        this.classification = [...currentIds];
      } else {
        this.classification = this.classification.filter(id => currentIds.includes(String(id)));
        currentIds.forEach(id => {
          if (!this.classification.includes(String(id))) {
            this.classification.push(String(id));
          }
        });
      }
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      m.redraw();
    });
  }
  saveDeadline() {
    if (!this.selectedSeason) return;
    this.savingDeadline = true;
    let formattedDate = null;
    if (this.fechaCierreInput) {
      // Convert input "YYYY-MM-DDTHH-mm" (or standard datetime-local) to ISO format
      const normalized = this.fechaCierreInput.replace('T', ' ').replace(/-/g, '-');
      const d = new Date(normalized);
      if (!isNaN(d.getTime())) {
        formattedDate = d.toISOString();
      }
    }
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/seasons/".concat(this.selectedSeasonId),
      body: {
        data: {
          attributes: {
            fechaCierreVotacionesPastorGorbea: formattedDate
          }
        }
      }
    }).then(response => {
      this.savingDeadline = false;
      // Update local store
      app.store.pushPayload(response);
      app.alerts.show({
        type: 'success'
      }, 'Fecha límite de votaciones actualizada correctamente.');
      m.redraw();
    }).catch(() => {
      this.savingDeadline = false;
      app.alerts.show({
        type: 'error'
      }, 'Ha ocurrido un error al guardar la fecha límite.');
      m.redraw();
    });
  }
  saveResults() {
    this.savingResults = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-result',
      body: {
        data: {
          attributes: {
            seasonId: this.selectedSeasonId,
            classification: this.classification,
            maxGoleadorLiga: this.maxGoleadorLiga.length > 0 ? this.maxGoleadorLiga : null,
            maxGoleadorTotal: this.maxGoleadorTotal.length > 0 ? this.maxGoleadorTotal : null,
            maxAsistenteLiga: this.maxAsistenteLiga.length > 0 ? this.maxAsistenteLiga : null,
            maxAsistenteTotal: this.maxAsistenteTotal.length > 0 ? this.maxAsistenteTotal : null,
            resultadoCopa: this.resultadoCopa || null,
            porteriasCero: this.porteriasCero,
            goleadasFavor: this.goleadasFavor,
            goleadasContra: this.goleadasContra
          }
        }
      }
    }).then(() => {
      this.savingResults = false;
      app.alerts.show({
        type: 'success'
      }, 'Resultados oficiales guardados y puntuaciones de los foreros recalculadas.');
      m.redraw();
    }).catch(() => {
      this.savingResults = false;
      app.alerts.show({
        type: 'error'
      }, 'Ha ocurrido un error al guardar los resultados.');
      m.redraw();
    });
  }
  scrapeClasificacion() {
    if (!this.selectedSeasonId) {
      app.alerts.show({
        type: 'error'
      }, 'Debes seleccionar una temporada primero.');
      return;
    }
    this.scrapingClasificacion = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-scrape-standings',
      params: {
        season_id: this.selectedSeasonId
      }
    }).then(response => {
      if (response && response.success && response.classification) {
        this.classification = response.classification;
        app.alerts.show({
          type: 'success'
        }, 'Clasificación cargada desde la web del Athletic. Recuerda guardar los resultados para persistir los cambios.');
      } else {
        app.alerts.show({
          type: 'error'
        }, 'No se pudo obtener la clasificación.');
      }
    }).catch(err => {
      console.error(err);
      const errMsg = err && err.response && err.response.error || (err == null ? void 0 : err.message) || 'Error al conectar con el servidor.';
      app.alerts.show({
        type: 'error'
      }, errMsg);
    }).finally(() => {
      this.scrapingClasificacion = false;
      m.redraw();
    });
  }
  recalculateScores() {
    this.recalculating = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-recalculate',
      body: {
        seasonId: this.selectedSeasonId
      }
    }).then(() => {
      this.recalculating = false;
      app.alerts.show({
        type: 'success'
      }, 'Puntuaciones recalculadas con éxito de manera síncrona.');
      m.redraw();
    }).catch(() => {
      this.recalculating = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al intentar recalcular las puntuaciones.');
      m.redraw();
    });
  }

  // Drag & Drop helper handlers (same as VotePage)
  dragStart(e, index) {
    this.draggedIndex = index;
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'move';
    }
  }
  dragOver(e, index) {
    e.preventDefault();
    if (this.draggedIndex === null || this.draggedIndex === index) return;
    const classification = [...this.classification];
    const draggedItem = classification[this.draggedIndex];
    classification.splice(this.draggedIndex, 1);
    classification.splice(index, 0, draggedItem);
    this.classification = classification;
    this.draggedIndex = index;
    m.redraw();
  }
  dragEnd() {
    this.draggedIndex = null;
  }
  moveUp(index) {
    if (index === 0) return;
    const classification = [...this.classification];
    const temp = classification[index];
    classification[index] = classification[index - 1];
    classification[index - 1] = temp;
    this.classification = classification;
    m.redraw();
  }
  moveDown(index) {
    if (index === this.classification.length - 1) return;
    const classification = [...this.classification];
    const temp = classification[index];
    classification[index] = classification[index + 1];
    classification[index + 1] = temp;
    this.classification = classification;
    m.redraw();
  }
  renderPlayerSelector(title, selectedIds, onUpdate) {
    const availablePlayers = this.players.filter(p => !selectedIds.includes(parseInt(p.id(), 10)));
    return m("div", {
      className: "Form-group"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;"
    }, m("label", {
      style: "font-weight: bold; margin: 0; color: var(--muted-color); font-size: 0.9em;"
    }, title), selectedIds.length === 0 ? m("span", {
      style: "font-size: 0.8em; color: var(--muted-color); font-style: italic;"
    }, "Sin definir") : selectedIds.length === 1 ? m("span", {
      style: "font-size: 0.8em; color: #4caf50; font-weight: bold;"
    }, "1 ganador") : m("span", {
      style: "font-size: 0.8em; color: #ff9800; font-weight: bold;"
    }, selectedIds.length, " ganadores (Empate)")), selectedIds.length > 0 && m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 10px;"
    }, selectedIds.map(id => {
      const player = this.players.find(p => parseInt(p.id(), 10) === id);
      const name = player ? player.name() : "Jugador #".concat(id);
      return m("span", {
        style: "display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15); border-radius: 16px; font-size: 0.9em; font-weight: 500;"
      }, player && player.photoUrl() && m("img", {
        src: player.photoUrl(),
        alt: "",
        style: "width: 18px; height: 18px; border-radius: 50%; object-fit: cover;"
      }), m("span", null, name), m("button", {
        type: "button",
        onclick: () => onUpdate(selectedIds.filter(item => item !== id)),
        style: "background: transparent; border: none; color: #ff5252; cursor: pointer; padding: 0 2px; font-size: 1.1em; line-height: 1; display: inline-flex; align-items: center;",
        title: "Quitar jugador"
      }, "\xD7"));
    })), m("select", {
      className: "FormControl",
      value: "",
      onchange: e => {
        const newId = parseInt(e.target.value, 10);
        if (!isNaN(newId) && newId > 0 && !selectedIds.includes(newId)) {
          onUpdate([...selectedIds, newId]);
        }
      },
      style: "border-radius: 8px;"
    }, m("option", {
      value: ""
    }, selectedIds.length === 0 ? '+ Seleccionar jugador ganador...' : '+ Añadir otro jugador (empate)...'), availablePlayers.map(p => m("option", {
      value: p.id()
    }, p.name()))));
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "GorbeaTaldezainaPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    const $rivalMap = {};
    this.rivals.forEach(r => {
      $rivalMap[String(r.id())] = r;
    });
    return m("div", {
      className: "GorbeaTaldezainaPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezaina")), m("div", {
      className: "EditRival-header",
      style: "margin-bottom: 40px; display: flex; align-items: center; gap: 20px;"
    }, m("div", {
      style: "height: 70px; width: 70px; border-radius: 12px; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255, 255, 255, 0.1);"
    }, m("i", {
      className: "fas fa-mountain",
      style: "font-size: 2.2rem; color: var(--heading-color);"
    })), m("div", null, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, "Taldezaina - Pastor del Gorbea"), m("p", {
      style: "color: var(--muted-color); font-size: 1.2em; margin-top: 4px;"
    }, "Configura la fecha l\xEDmite, introduce los resultados reales y recalcula puntuaciones."))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px; margin-bottom: 30px; max-width: 800px; display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 20px;"
    }, m("div", null, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 10px; color: var(--heading-color);"
    }, "Temporada a Gestionar"), m("select", {
      className: "FormControl",
      value: this.selectedSeasonId,
      onchange: e => this.onSeasonChange(parseInt(e.target.value)),
      style: "max-width: 300px; border-radius: 8px;"
    }, this.seasons.map(s => m("option", {
      value: s.id()
    }, s.name())))), app.session.user && app.session.user.isAdmin() && m(Button, {
      className: "Button Button--danger",
      onclick: () => app.modal.show(DeleteGorbeaSeasonDataModal, {
        seasons: this.seasons,
        onDeleted: () => this.loadInitialData()
      }),
      style: "border-radius: 8px; font-weight: bold; background-color: #d32f2f; border-color: #d32f2f; color: white;"
    }, m("i", {
      className: "fas fa-trash-alt",
      style: "margin-right: 6px;"
    }), " Eliminar Datos de Temporada")), m("div", {
      className: "Gorbea-Admin-Grid"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 30px;"
    }, m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 15px 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;"
    }, "\u23F1\uFE0F Fecha Cierre de Votaciones"), m("p", {
      style: "color: var(--muted-color); font-size: 12px; margin-bottom: 20px;"
    }, "Fecha l\xEDmite en la cual se bloquear\xE1 la posibilidad de que los foreros realicen o modifiquen sus apuestas."), m("div", {
      style: "display: flex; gap: 15px; align-items: center; flex-wrap: wrap;"
    }, m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: this.fechaCierreInput,
      oninput: e => this.fechaCierreInput = e.target.value,
      style: "max-width: 250px; border-radius: 8px;"
    }), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.saveDeadline(),
      loading: this.savingDeadline,
      style: "border-radius: 8px; font-weight: bold;"
    }, "Guardar Fecha"))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 15px 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;"
    }, "\uD83D\uDD04 Recalcular Puntuaciones Cach\xE9"), m("p", {
      style: "color: var(--muted-color); font-size: 12px; margin-bottom: 20px;"
    }, "Fuerza la ejecuci\xF3n s\xEDncrona del motor de recalculado para refrescar los puntos totales y el desglose de todos los foreros."), m(Button, {
      className: "Button Button--secondary",
      onclick: () => this.recalculateScores(),
      loading: this.recalculating,
      style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), " Recalcular Ahora")), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px; display: flex; flex-direction: column; gap: 20px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;"
    }, "\uD83C\uDFC6 Resultados Oficiales (Athletic y Estad\xEDsticas)"), this.renderPlayerSelector('Máximo Goleador Liga', this.maxGoleadorLiga, newIds => {
      this.maxGoleadorLiga = newIds;
      m.redraw();
    }), this.renderPlayerSelector('Máximo Goleador Total (Liga + Copa)', this.maxGoleadorTotal, newIds => {
      this.maxGoleadorTotal = newIds;
      m.redraw();
    }), this.renderPlayerSelector('Máximo Asistente Liga', this.maxAsistenteLiga, newIds => {
      this.maxAsistenteLiga = newIds;
      m.redraw();
    }), this.renderPlayerSelector('Máximo Asistente Total (Liga + Copa)', this.maxAsistenteTotal, newIds => {
      this.maxAsistenteTotal = newIds;
      m.redraw();
    }), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color); font-size: 0.9em;"
    }, "Resultado de Copa"), m("select", {
      className: "FormControl",
      value: this.resultadoCopa,
      onchange: e => this.resultadoCopa = e.target.value,
      style: "border-radius: 8px;"
    }, m("option", {
      value: ""
    }, "-- Sin definir --"), this.copaOptions.map(opt => m("option", {
      value: opt
    }, opt)))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color); font-size: 0.85em;"
    }, "Porter\xEDas 0"), m("input", {
      type: "number",
      className: "FormControl",
      min: "0",
      value: this.porteriasCero,
      onchange: e => this.porteriasCero = parseInt(e.target.value) || 0,
      style: "border-radius: 8px; text-align: center;"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color); font-size: 0.85em;"
    }, "Goleadas Favor"), m("input", {
      type: "number",
      className: "FormControl",
      min: "0",
      value: this.goleadasFavor,
      onchange: e => this.goleadasFavor = parseInt(e.target.value) || 0,
      style: "border-radius: 8px; text-align: center;"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color); font-size: 0.85em;"
    }, "Goleadas Contra"), m("input", {
      type: "number",
      className: "FormControl",
      min: "0",
      value: this.goleadasContra,
      onchange: e => this.goleadasContra = parseInt(e.target.value) || 0,
      style: "border-radius: 8px; text-align: center;"
    }))), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.saveResults(),
      loading: this.savingResults,
      style: "border-radius: 8px; font-weight: bold; margin-top: 10px; display: inline-flex; align-items: center; justify-content: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-save"
    }), " Guardar Resultados Oficiales"))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 15px 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;"
    }, "\uD83D\uDEE1\uFE0F Clasificaci\xF3n Oficial Primera Divisi\xF3n"), m("p", {
      style: "color: var(--muted-color); font-size: 12px; margin-bottom: 20px;"
    }, "Clasificaci\xF3n oficial final de La Liga Santander. Se puede reordenar manualmente aqu\xED o dejar que el scraping diario la actualice de forma automatizada."), m("div", {
      style: "margin-bottom: 20px; display: flex; justify-content: flex-end;"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: () => this.scrapeClasificacion(),
      loading: this.scrapingClasificacion,
      style: "border-radius: 8px; font-weight: bold; display: inline-flex; align-items: center; justify-content: center; gap: 8px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease; color: var(--text-color); padding: 8px 16px;"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), " Cargar Clasificaci\xF3n de Web Athletic")), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px; max-height: 800px; overflow-y: auto; padding: 5px; background: rgba(0,0,0,0.1); border-radius: 12px; border: 1px solid rgba(255,255,255,0.04);"
    }, this.classification.map(rivalId => $rivalMap[String(rivalId)]).filter(Boolean).map((rival, index) => {
      const localTeamName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic Club';
      const isAthletic = rival.name() === localTeamName;
      return m("div", {
        key: rival.id(),
        draggable: true,
        ondragstart: e => this.dragStart(e, index),
        ondragover: e => this.dragOver(e, index),
        ondragend: () => this.dragEnd(),
        style: "display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; border-radius: 8px; border: 1px solid ".concat(isAthletic ? 'var(--primary-color)' : 'rgba(255,255,255,0.08)', "; background: ").concat(isAthletic ? 'rgba(255, 255, 255, 0.06)' : 'rgba(255,255,255,0.02)', "; cursor: grab; transition: all 0.2s;")
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        style: "font-weight: bold; color: var(--muted-color); font-size: 14px; min-width: 20px;"
      }, index + 1), rival.attribute('escudo') ? m("img", {
        src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(rival.attribute('escudo')),
        alt: "",
        style: "width: 24px; height: 24px; object-fit: contain;"
      }) : m("div", {
        style: "width: 24px; height: 24px; background: rgba(255,255,255,0.05); border-radius: 50%;"
      }), m("span", {
        style: "font-weight: ".concat(isAthletic ? 'bold' : 'normal', "; color: ").concat(isAthletic ? 'var(--primary-color)' : 'var(--text-color)', ";")
      }, rival.name())), m("div", {
        style: "display: flex; gap: 4px;"
      }, m("button", {
        type: "button",
        className: "Button Button--icon Button--link",
        disabled: index === 0,
        onclick: () => this.moveUp(index),
        title: "Subir"
      }, m("i", {
        className: "fas fa-chevron-up",
        style: "font-size: 11px;"
      })), m("button", {
        type: "button",
        className: "Button Button--icon Button--link",
        disabled: index === this.classification.length - 1,
        onclick: () => this.moveDown(index),
        title: "Bajar"
      }, m("i", {
        className: "fas fa-chevron-down",
        style: "font-size: 11px;"
      }))));
    }))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaTaldezainaPage', GorbeaTaldezainaPage);